import { useEffect, useState } from 'react'

export function useScrollReveal(scrollContainerId: string): { isHidden: boolean } {
  const [isHidden, setIsHidden] = useState(false)

  useEffect(() => {
    const el = document.getElementById(scrollContainerId)
    if (!el) return

    let lastScrollTop = el.scrollTop

    const handleScroll = () => {
      const scrollTop = el.scrollTop

      if (scrollTop <= 0) {
        setIsHidden(false)
        lastScrollTop = scrollTop
        return
      }

      if (scrollTop > lastScrollTop) {
        setIsHidden(true)
      } else if (scrollTop < lastScrollTop) {
        setIsHidden(false)
      }

      lastScrollTop = scrollTop
    }

    el.addEventListener('scroll', handleScroll, { passive: true })
    return () => el.removeEventListener('scroll', handleScroll)
  }, [scrollContainerId])

  return { isHidden }
}
